import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import {
    APIURL,
    CLOUDFRONT_URL,
    IMAGE_FULL_URL,
    PAGE10,
    PORT,
} from "../../../config/config";
import NumberFormat from "react-number-format";
import * as moment from "moment";
import "moment/locale/th";
import { Button, ModalHeader, Modal, ModalBody, ModalFooter } from "reactstrap";
import { connect } from "react-redux";
import { MonthUtil } from "../../../utils/monthUtil";
import Loading from "../../Loading";
import OutstandingBalanceComponent from "../OutstandingBalanceComponent";
import {
    checkGroupPermission,
    getGroupPermission,
} from "../../../services/grouppermission";
import { CarUtil } from "../../../utils/carUtil";
import { CarSellUtil, CarsUtil } from "../../../utils/carSellUtil";
import DebtWarning from "./DebtWarning";
import star from "../../../assets/star.png";
import {
    getSumCostAfterSell,
    getSumCostBeforeSellNoRepair,
    getSumCostFinanceAfterSell,
    getSumCostSellPayByCustomer,
} from "../../../services/costProfitService";
import { DateUtil } from "../../../utils/dateUtil";
import html2canvas from "@html2canvas/html2canvas";

const port = Number(window.env.PORT);

class CarSalesSummaryModal extends Component {
    timerId = null;

    constructor(props) {
        super(props);
        this.state = {
            menuID: [26, 805, 807, 127, 104, 808, 809, 810, 811, 704, 813, 814, 815],
            grouppermissions: [],
            btnClick: "",
            carsellSelect: 0,
            car_sell_id: 0,
            car_sell: "",
            lists: [],
            car_sell_selected: {},
            car_claim: {},
            user: {},
            car_sell_detail: {},
            page: 1,
            car_sell_count: 0,
            is_search: false,
            month_year_list: [],
            sum_price: 0,
            sum_profit: 0,
            month_list_thai: 0,
            month_list: "all",
            isLoading: false,
            width: 0,
            height: 0,
            car_sell_remain: 0,
            is_sell_date_modal: false,
            startDateCarSell: new Date(),
            is_receipt_open: false,
            company_setting: null,
            carBase64Img: "",
            debtors_query: "",
            car_status: [],
            car_status_id: 0,
            is_issue_date_modal: false,
            isSummaryModalOpen: false,
            selectedCarSellId: 0,
            bill_no: "",
            bill_discount: 0,
            actionType: "บันทึก",
            isDeliverCarPDF: false,
            card_id_image: null,
            car_deliver_image: null,
            filter_car_statuses: [],
            isDeliverCarPDFCarOk: false,
            profile: null,
            car_sell_pay_list: [],
            firstLoad: true,
            car_sell_type: [],
            car_sell_type_id: 0,
            bank: [],
            bank_finance_id: 0,
            page_search: 1,
            count_search: 0,
            search_text: "",
            carImageBase64: null,
            isCarImageLoading: false,
            isDownloadImage: false
        };
        this.loadCarSellMonthList = this.loadCarSellMonthList.bind(this);
        this.sellMonthYearChange = this.sellMonthYearChange.bind(this);
        this.loadSellTotal = this.loadSellTotal.bind(this);
        this.loadCompanySetting = this.loadCompanySetting.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.loadCompanyLogoBase64 = this.loadCompanyLogoBase64.bind(this);
        this.loadGroupPermission = this.loadGroupPermission.bind(this);
        this.loadCarSellData = this.loadCarSellData.bind(this);
        this.loadCarStatusData = this.loadCarStatusData.bind(this);
        this.onCarSellListNoteUpdate = this.onCarSellListNoteUpdate.bind(this);
        this.onCarSellListNoteFormEdit = this.onCarSellListNoteFormEdit.bind(this);
        this.loadImageBase64 = this.loadImageBase64.bind(this);
        this.loadProfile = this.loadProfile.bind(this);
        this.checkCostPermission = this.checkCostPermission.bind(this);
        this.sellMonthYearChange = this.sellMonthYearChange.bind(this);
        this.loadSellTotal = this.loadSellTotal.bind(this);
        this.renderCostSell = this.renderCostSell.bind(this);
        this.loadCarSellTypeData = this.loadCarSellTypeData.bind(this);
        this.generatePrintDocument = this.generatePrintDocument.bind(this);
        this.loadCarImage = this.loadCarImage.bind(this);
        this.handleDownloadImage = this.handleDownloadImage.bind(this);

        // Create refs for image capture
        this.imageCaptureRef = React.createRef();
    }

    loadCarStatusData() {
        axios
            .get(APIURL + "/car_status/sell/1")
            .then((res) => {
                if (this.mounted) {
                    this.setState({car_status: res.data});
                }
                //alert (res.data)
            })
            .catch((error) => {
                console.log("error:", error);
                this.setState({car_status: []});
            });
    }

    loadGroupPermission() {
        let type = this.props.type;
        let menuID = this.state.menuID;
        getGroupPermission(type, menuID).then((res) => {
            if (res.data.result === "success") {
                if (this.mounted) {
                    this.setState({
                        grouppermissions: res.data.grouppermissions,
                    });
                }
            }
        });
    }

    async loadCompanyLogoBase64() {
        let uri = APIURL + "/company_setting/logoimage/1";
        await axios
            .get(uri)
            .then((res) => {
                let body = res.data.body;
                if (this.mounted) {
                    this.setState({carBase64Img: body});
                }
            })
            .catch((error) => {
                console.log("error:", error);
            });
    }

    loadCarSellTypeData() {
        axios
            .get(APIURL + "/car_sell_type/")
            .then((res) => {
                if (this.mounted) {
                    this.setState({car_sell_type: res.data});
                }
                //alert (res.data)
            })
            .catch((error) => {
                this.setState({car_sell_type: []});
            });
    }

    async loadImageBase64(image_key, state_name) {
        let uri = APIURL + "/image_base64";

        let data = {
            table: "car_sell",
            image_key: image_key,
        };

        await axios
            .post(uri, data)
            .then((res) => {
                let body = res.data.body;
                this.setState({[state_name]: body});
            })
            .catch((error) => {
                console.log("error:", error);
            });
    }

    loadProfile(customer_id, car_sell) {
        axios.get(APIURL + "/profile/customer/" + customer_id).then((res) => {
            let profile = res.data.length === 0 ? null : res.data[0];
            this.setState(
                {
                    isDeliverCarPDFCarOk: true,
                    car_sell: car_sell,
                    profile: profile,
                    isLoading: false,
                },
                () => {
                    this.timerId = setTimeout(() => {
                        this.setState({
                            isDeliverCarPDFCarOk: false,
                        });
                    }, 2000);
                }
            );
        });
    }

    toQueryString(paramsObject) {
        return Object.keys(paramsObject)
            .map(
                (key) =>
                    `${encodeURIComponent(key)}=${encodeURIComponent(paramsObject[key])}`
            )
            .join("&");
    }

    componentWillMount() {
        this.setState({
            user: JSON.parse(this.props.user),
        });
    }

    updateWindowDimensions() {
        if (this.mounted) {
            this.setState({width: window.innerWidth, height: window.innerHeight});
        }
    }

    componentDidUpdate(prevProps) {
        // ตรวจจับการเปลี่ยนแปลงของ car_sell_id prop
        if (this.props.car_sell_id !== prevProps.car_sell_id && this.props.car_sell_id > 0) {
            this.setState({
                car_sell_id: this.props.car_sell_id,
                car_sell: "",
                car_sell_count: 0
            }, () => {
                this.loadCarSellData();
            });
        }
    }

    componentWillUnmount() {
        this.mounted = false;
        clearTimeout(this.timerId);
        window.removeEventListener("resize", this.updateWindowDimensions);
    }

    async componentDidMount() {
        this.mounted = true;

        let car_license_plate_new = CarSellUtil.getCarSellSelect();

        this.loadGroupPermission();
        this.loadCompanyLogoBase64();
        this.loadCompanySetting();
        this.loadCarStatusData();
        this.loadCarSellMonthList();
        this.loadCarSellTypeData();

        const {car_sell_id} = this.props;
        if (car_sell_id > 0) {
            this.setState({car_sell_id}, () => {
                this.loadCarSellData();
            });
        }

        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions);

        CarsUtil.removeCarSelect();
    }

    loadCompanySetting() {
        axios.get(APIURL + "/company_setting/1").then((res) => {
            let data = res.data;
            let company_setting = data.company_setting;
            if (company_setting !== null) {
                if (this.mounted) {
                    this.setState({company_setting: company_setting});
                }
            }
        });
    }

    loadCarSellMonthList() {
        let uri = APIURL + "/car_sell/list/month";
        axios
            .get(uri)
            .then((res) => {
                if (res.data.length > 0) {
                    let months = res.data;
                    let month_year_list = months.map((month) => {
                        let month_list_thai = MonthUtil.convertMonthYear(month.month_list);
                        return {
                            ...month,
                            month_list_thai: month_list_thai,
                        };
                    });

                    if (this.mounted) {
                        this.setState(
                            {
                                month_year_list: month_year_list,
                            },
                            () => this.loadSellTotal(null)
                        );
                    }
                }
            })
            .catch((error) => {
            });
    }

    loadCarSellData(page) {
        //โหลดครั้งแรกแบบไม่ค้นหา สามารถเลือกตาม page ได้
        if (typeof page === "undefined") page = 1;

        const {car_sell_id} = this.props;
        if (car_sell_id === 0) {
            console.log('car_sell_id is 0, skipping data load');
            return;
        }

        let username = this.state.user.user;
        // let uri = APIURL + '/car_sell/page/'+page
        let uri = APIURL + "/car_sell/" + car_sell_id;

        axios.get(uri)
            .then(response => {
                const carSellData = Array.isArray(response.data) ? response.data : [response.data];

                this.setState({
                    lists: carSellData,
                    car_sell_count: 1,
                    isLoading: false,
                }, () => {
                    // Load car image when data is ready
                    if (carSellData && carSellData.length > 0) {
                        this.loadCarImage(carSellData[0]);
                    }
                });
            })
            .catch(error => {
                this.setState({
                    lists: [],
                    car_sell_count: 0,
                    isLoading: false,
                });
            });
    }

    onCarSellListNoteFormEdit(e, car_sell_id) {
        e.preventDefault();
        let list_note = e.target.value;

        // Ensure lists is always an array before mapping
        let listsArray = Array.isArray(this.state.lists) ? this.state.lists : [];
        let car_sell_list = listsArray.map((car_sell) =>
            car_sell.car_sell_id === car_sell_id
                ? {...car_sell, sell_list_note: list_note, car_sell_edit: true}
                : car_sell
        );

        this.setState({
            lists: car_sell_list,
        });
    }

    onCarSellListNoteUpdate(car_sell_id, sell_list_note) {
        // update sell_list_note
        let uri = APIURL + "/car_sell/sell_list_note/" + car_sell_id;
        let data = {sell_list_note: sell_list_note};
        axios
            .put(uri, data)
            .then((res) => {
                if (res.status === 200) {
                    // Ensure lists is always an array before mapping
                    let listsArray = Array.isArray(this.state.lists) ? this.state.lists : [];
                    let car_sell_list = listsArray.map((car_sell) =>
                        car_sell.car_sell_id === car_sell_id
                            ? {...car_sell, car_sell_edit: false, car_sell_save: true}
                            : car_sell
                    );
                    this.setState({
                        lists: car_sell_list,
                    });
                    this.timerId = setTimeout(() => {
                        // Ensure lists is always an array before mapping
                        let listsArray = Array.isArray(this.state.lists) ? this.state.lists : [];
                        let car_sell_list = listsArray.map((car_sell) =>
                            car_sell.car_sell_id === car_sell_id
                                ? {...car_sell, car_sell_edit: false, car_sell_save: false}
                                : car_sell
                        );
                        this.setState({
                            lists: car_sell_list,
                        });
                    }, 2000);
                }
            })
            .catch((error) => {
            });
    }

    checkCarSellDebtors(car_sell_id) {
        let api = APIURL + "/debtors/car_sell_id/" + car_sell_id;
        //  alert(api)
        axios
            .get(api)
            .then((res) => {
                this.setState({debtors: res.data[0]});
            })
            .catch((error) => {
                //alert('error' + error)
                this.setState({debtors: {}});
            });
    }

    convertImgToBase64URL(url, callback, outputFormat) {
        let img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = function () {
            var canvas = document.createElement("CANVAS"),
                ctx = canvas.getContext("2d"),
                dataURL;
            canvas.height = img.height;
            canvas.width = img.width;
            ctx.drawImage(img, 0, 0);
            dataURL = canvas.toDataURL(outputFormat);
            callback(dataURL);
            canvas = null;
        };
        img.src = url;
    }

    sellMonthYearChange(e) {
        let value = e.target.value;

        this.setState(
            {
                month_list: value,
            },
            () => {
                this.loadSellTotal(value);
            }
        );
    }

    loadSellTotal(data) {
        let typeLoad = "";
        let start_date = "";
        let end_date = "";

        if (data === null) {
            typeLoad = "all";
        } else if (data === "all") {
            typeLoad = "all";
        } else {
            typeLoad = "date";
        }

        let month_list_thai = "";
        if (typeLoad === "all") {
            start_date = "all";
            end_date = "all";
            month_list_thai = "all";
        } else {
            const month_year_list = this.state.month_year_list.find(
                (month_year) => month_year.month_list === data
            );
            start_date = month_year_list.start_date;
            end_date = month_year_list.end_date;
            month_list_thai = month_year_list.month_list_thai;
        }

        let uri = APIURL + "/car_sell/total/" + start_date + "/" + end_date;

        this.setState({isLoading: true}, () => {
            axios
                .get(uri)
                .then((res) => {
                    let sum_price = res.data.sum_price;
                    let sum_profit = res.data.sum_profit;

                    if (start_date === "all") {
                        this.setState(
                            {
                                sum_price: sum_price,
                                sum_profit: sum_profit,
                                month_list_thai: month_list_thai,
                                isLoading: false,
                            },
                            () => {
                                let firstLoad = this.state.firstLoad;
                                if (firstLoad === false) {
                                    this.loadCarSellData(this.state.page);
                                }
                            }
                        );
                    } else {
                        let carSells = res.data.carSells;
                        this.setState({
                            is_search: true,
                            sum_price: sum_price,
                            sum_profit: sum_profit,
                            month_list_thai: month_list_thai,
                            lists: carSells,
                            isLoading: false,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        });
    }

    toggleSummaryModal = (car_sell_id = 0) => {
        this.setState({
            isSummaryModalOpen: !this.state.isSummaryModalOpen,
            selectedCarSellId: car_sell_id,
        });
    };

    // Print Preview Functions

    generatePrintDocument = (car_sell) => {
        // Use default settings since print preview is removed
        const includeImages = true;
        const includeCustomerInfo = true;
        const includeFinancialDetails = true;
        const paperSize = 'A4';
        const orientation = 'portrait';

        // Calculate financial data (same logic as in render)
        let car_sell_type_id = Number(car_sell.car_sell_type_id);
        let real_sell_price = Number(car_sell.real_sell_price);
        let tax_invoice_amount = Number(car_sell.tax_invoice_amount);
        let rate_finance = Number(car_sell.rate_finance);
        let sum_down = Number(car_sell.sum_down);
        let rate_finance_tax_invoice_amount = tax_invoice_amount !== 0 ? tax_invoice_amount : rate_finance;

        let sum_car_income = rate_finance_tax_invoice_amount + sum_down;
        let sum_car_income_total = car_sell_type_id === 1 ? real_sell_price : sum_car_income;

        let sum_car_cost_total = (car_sell.car_cost === null || car_sell.car_cost === undefined ? 0 : car_sell.car_cost) + (car_sell.vat_buy === null || car_sell.vat_buy === undefined ? 0 : car_sell.vat_buy) + getSumCostBeforeSellNoRepair(car_sell);
        let sum_car_cost_repair = car_sell.car_cost_repair === null || car_sell.car_cost_repair === undefined ? 0 : car_sell.car_cost_repair;
        let sum_cost_sell_and_finance = getSumCostAfterSell(car_sell) + getSumCostFinanceAfterSell(car_sell);
        let sum_car_cost_finish = sum_car_cost_total + sum_car_cost_repair + sum_cost_sell_and_finance;

        // Calculate profit/loss for styling
        let profit_loss = sum_car_income_total - sum_car_cost_finish;

        // Build content array with 3-column layout
        const content = [
            // Header
            {
                text: 'สรุปการขายรายคัน',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 0, 20]
            },

            // Three Column Layout
            {
                columns: [
                    // Column 1: ข้อมูลรถยนต์ (32%)
                    {
                        width: "32%",
                        style: 'carInfoColumn',
                        stack: [
                            {
                                text: 'ข้อมูลรถยนต์',
                                style: 'columnHeader',
                                margin: [0, 0, 0, 15]
                            },
                            {
                                text: [
                                    {text: 'ทะเบียนใหม่: ', style: 'infoLabel'},
                                    {
                                        text: `${car_sell.car_license_plate_new || '-'} ${car_sell.province_name_new || ''}`.trim(),
                                        style: 'infoValue'
                                    }
                                ],
                                margin: [0, 0, 0, 8]
                            },
                            {
                                text: [
                                    {text: 'ทะเบียนเดิม: ', style: 'infoLabel'},
                                    {
                                        text: `${car_sell.car_license_plate_old || '-'} ${car_sell.province_name_old || ''}`.trim(),
                                        style: 'infoValue'
                                    }
                                ],
                                margin: [0, 0, 0, 8]
                            },
                            {
                                text: [
                                    {text: 'รุ่นรถ: ', style: 'infoLabel'},
                                    {
                                        text: `${car_sell.car_name || '-'} สี${car_sell.car_color_name || '-'}`.trim(),
                                        style: 'infoValue'
                                    }
                                ],
                                margin: [0, 0, 0, 8]
                            },
                            {
                                text: [
                                    {text: 'วันที่ซื้อ: ', style: 'infoLabel'},
                                    {
                                        text: car_sell.car_date_in ? moment(car_sell.car_date_in).locale('th').format('LL') : '-',
                                        style: 'infoValue'
                                    }
                                ],
                                margin: [0, 0, 0, 8]
                            },
                            {
                                text: [
                                    {text: 'วันที่ขาย: ', style: 'infoLabel'},
                                    {
                                        text: car_sell.car_sell_date ? moment(car_sell.car_sell_date).locale('th').format('LL') : '-',
                                        style: 'infoValue'
                                    }
                                ],
                                margin: [0, 0, 0, 8]
                            },
                            {
                                text: [
                                    {text: 'วันที่ออกรถ: ', style: 'infoLabel'},
                                    {
                                        text: car_sell.car_issue_date ? moment(car_sell.car_issue_date).locale('th').format('LL') : '-',
                                        style: 'infoValue'
                                    }
                                ],
                                margin: [0, 0, 0, 8]
                            }
                        ]
                    },

                    // Column 2: ภาพรถและข้อมูลผู้ซื้อ (33%)
                    {
                        width: "33%",
                        style: 'imageColumn',
                        stack: [
                            {
                                text: 'ภาพรถและข้อมูลผู้ซื้อ',
                                style: 'columnHeader',
                                margin: [0, 0, 0, 15]
                            },

                            // Car Image
                            ...(includeImages && this.state.carImageBase64 ? [{
                                image: this.state.carImageBase64,
                                width: 180,
                                alignment: 'center',
                                margin: [0, 0, 0, 15]
                            }] : []),

                            // Customer Information
                            ...(includeCustomerInfo ? [{
                                text: 'ข้อมูลผู้ซื้อ',
                                style: 'sectionHeader',
                                margin: [0, 0, 0, 10]
                            },
                                {
                                    text: [
                                        {text: 'ชื่อ: ', style: 'infoLabel'},
                                        {
                                            text: `${car_sell.customer_name || ''} ${car_sell.customer_lastname || ''}`.trim(),
                                            style: 'infoValue'
                                        }
                                    ],
                                    margin: [0, 0, 0, 6]
                                },
                                {
                                    text: [
                                        {text: 'เบอร์โทร: ', style: 'infoLabel'},
                                        {text: car_sell.customer_mobile || '-', style: 'infoValue'}
                                    ],
                                    margin: [0, 0, 0, 6]
                                },
                                ...(car_sell.customer_mobile2 ? [{
                                    text: [
                                        {text: 'เบอร์โทร 2: ', style: 'infoLabel'},
                                        {text: car_sell.customer_mobile2, style: 'infoValue'}
                                    ],
                                    margin: [0, 0, 0, 6]
                                }] : []),
                                {
                                    text: [
                                        {text: 'ประเภท: ', style: 'infoLabel'},
                                        {
                                            text: CarUtil.convertVatPersonToName(car_sell.customer_type) || '-',
                                            style: 'infoValue'
                                        }
                                    ],
                                    margin: [0, 0, 0, 6]
                                },
                                {
                                    text: [
                                        {text: 'ไฟแนนซ์: ', style: 'infoLabel'},
                                        {text: car_sell.bank_finance_name_new || '-', style: 'infoValue'}
                                    ],
                                    margin: [0, 0, 0, 0]
                                }] : [])
                        ]
                    },

                    // Column 3: ข้อมูลการเงิน (35%)
                    {
                        width: "35%",
                        style: 'financeColumn',
                        stack: [
                            {
                                text: 'ข้อมูลการเงิน',
                                style: 'columnHeader',
                                margin: [0, 0, 0, 15]
                            },

                            ...(includeFinancialDetails ? [{
                                text: [
                                    {text: 'ราคาปกติ: ', style: 'infoLabel'},
                                    {
                                        text: `${Number(car_sell.normal_sell_price || 0).toFixed(2).toLocaleString()} บาท`,
                                        style: 'infoValue'
                                    }
                                ],
                                margin: [0, 0, 0, 8]
                            },
                                {
                                    text: [
                                        {text: 'ราคาขายจริง: ', style: 'infoLabel'},
                                        {text: `${Number(real_sell_price || 0).toFixed(2).toLocaleString()} บาท`, style: 'infoValue'}
                                    ],
                                    margin: [0, 0, 0, 8]
                                },
                                {
                                    text: [
                                        {text: 'จัดไฟแนนซ์: ', style: 'infoLabel'},
                                        {
                                            text: `${Number(rate_finance_tax_invoice_amount || 0).toFixed(2).toLocaleString()} บาท`,
                                            style: 'infoValue'
                                        }
                                    ],
                                    margin: [0, 0, 0, 8]
                                },
                                {
                                    text: [
                                        {text: 'เงินดาวน์: ', style: 'infoLabel'},
                                        {text: `${Number(sum_down || 0).toFixed(2).toLocaleString()} บาท`, style: 'infoValue'}
                                    ],
                                    margin: [0, 0, 0, 8]
                                },
                                {
                                    text: [
                                        {text: 'ออกรถทั้งหมด: ', style: 'infoLabel'},
                                        {
                                            text: `${Number(car_sell.total_outof_car || 0).toFixed(2).toLocaleString()} บาท`,
                                            style: 'infoValue'
                                        }
                                    ],
                                    margin: [0, 0, 0, 15]
                                },
                                {
                                    text: [
                                        {text: 'ต้นทุนรถ: ', style: 'infoLabel'},
                                        {
                                            text: `${Number(sum_car_cost_total || 0).toFixed(2).toLocaleString()} บาท`,
                                            style: 'infoValue'
                                        }
                                    ],
                                    margin: [0, 0, 0, 8]
                                },
                                {
                                    text: [
                                        {text: 'ค่าซ่อมรถ: ', style: 'infoLabel'},
                                        {
                                            text: `${Number(sum_car_cost_repair || 0).toFixed(2).toLocaleString()} บาท`,
                                            style: 'infoValue'
                                        }
                                    ],
                                    margin: [0, 0, 0, 8]
                                },
                                {
                                    text: [
                                        {text: 'ต้นทุนรวม: ', style: 'infoLabel'},
                                        {
                                            text: `${Number(sum_car_cost_finish || 0).toFixed(2).toLocaleString()} บาท`,
                                            style: 'infoValue'
                                        }
                                    ],
                                    margin: [0, 0, 0, 15]
                                },
                                {
                                    text: [
                                        {text: 'รายได้รวม: ', style: 'infoLabel'},
                                        {
                                            text: `${Number(sum_car_income_total || 0).toFixed(2).toLocaleString()} บาท`,
                                            style: 'infoValueHighlight'
                                        }
                                    ],
                                    margin: [0, 0, 0, 8]
                                },
                                {
                                    text: [
                                        {text: 'กำไร/ขาดทุน: ', style: 'infoLabel'},
                                        {
                                            text: `${Number(profit_loss || 0).toFixed(2).toLocaleString()} บาท`,
                                            style: profit_loss >= 0 ? 'infoValueProfit' : 'infoValueLoss'
                                        }
                                    ],
                                    margin: [0, 0, 0, 0]
                                }] : [])
                        ]
                    }
                ],
                columnGap: 20,
                margin: [0, 0, 0, 20]
            },

            // Additional Information (if exists)
            ...(car_sell.sell_comment ? [{
                text: 'หมายเหตุการขาย',
                style: 'subheader',
                margin: [0, 20, 0, 10],
                alignment: 'center'
            },
                {
                    text: car_sell.sell_comment,
                    style: 'commentText',
                    margin: [0, 0, 0, 10]
                }] : []),

            // Footer
            {
                text: `พิมพ์เมื่อ: ${moment().locale('th').format('LL เวลา HH:mm:ss')}`,
                style: 'footer',
                alignment: 'center',
                margin: [0, 30, 0, 0]
            }
        ];

        const docDefinition = {
            content: content,

            styles: {
                header: {
                    fontSize: 18,
                    bold: true,
                    margin: [0, 0, 0, 20]
                },
                subheader: {
                    fontSize: 14,
                    bold: true,
                    margin: [0, 10, 0, 5]
                },
                columnHeader: {
                    fontSize: 14,
                    bold: true,
                    color: '#2c3e50',
                    decoration: 'underline'
                },
                sectionHeader: {
                    fontSize: 12,
                    bold: true,
                    color: '#34495e',
                    margin: [0, 10, 0, 5]
                },
                infoLabel: {
                    fontSize: 11,
                    bold: true,
                    color: '#2c3e50'
                },
                infoValue: {
                    fontSize: 11,
                    color: '#2c3e50'
                },
                infoValueHighlight: {
                    fontSize: 11,
                    bold: true,
                    color: '#27ae60'
                },
                infoValueProfit: {
                    fontSize: 11,
                    bold: true,
                    color: '#27ae60'
                },
                infoValueLoss: {
                    fontSize: 11,
                    bold: true,
                    color: '#e74c3c'
                },
                commentText: {
                    fontSize: 11,
                    italic: true,
                    color: '#7f8c8d'
                },
                footer: {
                    fontSize: 10,
                    italics: true,
                    color: '#95a5a6'
                },
                carInfoColumn: {
                    fontSize: 11,
                    lineHeight: 1.4
                },
                imageColumn: {
                    fontSize: 11,
                    lineHeight: 1.4
                },
                financeColumn: {
                    fontSize: 11,
                    lineHeight: 1.4
                }
            },

            pageSize: paperSize,
            pageOrientation: orientation,

            defaultStyle: {
                font: 'THSarabunNew',
                fontSize: 11,
                lineHeight: 1.4
            }
        };

        return docDefinition;
    };

    // Download Image Function using html2canvas
    handleDownloadImage = async (car_sell_id) => {
        this.setState({
            isDownloadImage: true
        }, async () => {
            try {
                const element = this.imageCaptureRef.current;
                const canvas = await html2canvas(element, {
                    letterRendering: 1,
                    allowTaint: true,
                    useCORS: true,
                    scale: 2, // Higher quality
                    backgroundColor: '#ffffff'
                });

                const data = canvas.toDataURL('image/jpg', 0.95); // 95% quality
                const link = document.createElement('a');

                if (typeof link.download === 'string') {
                    link.href = data;
                    const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss');
                    // ใช้ car_sell_id ถ้ามี ถ้าไม่มีให้ใช้เฉพาะ timestamp
                    const filename = car_sell_id ?
                        `CarSalesSummary_ID${car_sell_id}_${timestamp}.jpg` :
                        `CarSalesSummary_${timestamp}.jpg`;
                    link.download = filename;

                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    window.open(data);
                }

            } catch (error) {
                console.error('Error generating image:', error);
                alert('เกิดข้อผิดพลาดในการสร้างรูปภาพ กรุณาลองใหม่อีกครั้ง');
            } finally {
                setTimeout(() => {
                    this.setState({isDownloadImage: false});
                }, 1200);
            }
        });
    };

    // Car Image Loading Function
    loadCarImage = async (car_sell) => {
        if (car_sell && car_sell.car_upload_key) {
            this.setState({isCarImageLoading: true});
            try {
                await this.loadImageBase64(car_sell.car_upload_key, 'carImageBase64');
            } catch (error) {
                console.error('Failed to load car image:', error);
                // Try fallback with car_upload_filename if car_upload_key fails
                if (car_sell.car_upload_filename) {
                    try {
                        await this.loadImageBase64(car_sell.car_upload_filename, 'carImageBase64');
                    } catch (fallbackError) {
                        console.error('Failed to load car image with filename fallback:', fallbackError);
                    }
                }
            } finally {
                this.setState({isCarImageLoading: false});
            }
        }
    };

    checkCostPermission() {
        if (PORT === 9059 && this.props.type === "admin") {
            return true;
        } else if (PORT === 9059 && this.props.type === "manager") {
            return false;
        } else if (
            PORT !== 9008 &&
            PORT !== 9005 &&
            PORT !== 9043 &&
            PORT !== 9034
        ) {
            if (this.props.type === "admin" || this.props.type === "manager") {
                return true;
            }
        }
        return false;
    }

    renderCostSell(car_sell, to_fixed) {
        let sum_cost_sell = getSumCostAfterSell(car_sell);
        let sum_cost_finance = getSumCostFinanceAfterSell(car_sell);

        if (port === 9048) {
            let car_external_commission = car_sell.car_external_commission;
            let sales_commission = car_sell.sales_commission;
            return (
                <>
                    {this.checkCostPermission() ? (
                        <tr
                            className={car_external_commission <= 0 ? "hidden" : "text-dark"}
                        >
                            <td className="text-left text-nowrap">
                                <span>ค่านายหน้า :</span>
                            </td>
                            <td className="text-right text-dark text-nowrap">
                <span>
                  <NumberFormat
                      value={Number(car_external_commission || 0).toFixed(to_fixed)}
                      displayType={"text"}
                      thousandSeparator={true}
                  />{" "}
                    &nbsp; บาท
                </span>
                            </td>
                        </tr>
                    ) : null}

                    {this.checkCostPermission() ? (
                        <tr className={sales_commission <= 0 ? "hidden" : "text-dark"}>
                            <td className="text-left text-nowrap">
                                <span>ค่าคอมฝ่ายขาย :</span>
                            </td>
                            <td className="text-right text-dark text-nowrap">
                <span>
                  <NumberFormat
                      value={Number(sales_commission || 0).toFixed(to_fixed)}
                      displayType={"text"}
                      thousandSeparator={true}
                  />{" "}
                    &nbsp; บาท
                </span>
                            </td>
                        </tr>
                    ) : null}
                </>
            );
        } else {
            return (
                <>
                    {this.checkCostPermission() ? (
                        <>
                            <tr className={sum_cost_sell <= 0 ? "hidden" : "text-dark"}>
                                <td className="text-left text-nowrap">
                                    <span>รวมค่าใช้จ่ายการขาย :</span>
                                </td>
                                <td className="text-right text-dark text-nowrap">
                  <span>
                    <NumberFormat
                        value={Number(sum_cost_sell || 0).toFixed(to_fixed)}
                        displayType={"text"}
                        thousandSeparator={true}
                    />{" "}
                      &nbsp; บาท
                  </span>
                                </td>
                            </tr>
                            <tr className={sum_cost_finance <= 0 ? "hidden" : "text-dark"}>
                                <td className="text-left text-nowrap">
                                    <span>รวมค่าใช้จ่ายจากไฟแนนซ์ :</span>
                                </td>
                                <td className="text-right text-dark text-nowrap">
                  <span>
                    <NumberFormat
                        value={Number(sum_cost_finance || 0).toFixed(to_fixed)}
                        displayType={"text"}
                        thousandSeparator={true}
                    />{" "}
                      &nbsp; บาท
                  </span>
                                </td>
                            </tr>
                        </>
                    ) : null}
                </>
            );
        }
    }

    render() {
        const {isOpen, toggle, car_sell_id} = this.props;
        let width = this.state.width;
        let sale_lists = this.state.lists;

        // let width = this.state.width
        let imgWidth = "";
        if (width >= 1340) {
            imgWidth = "280px";
        } else if (width >= 1024) {
            imgWidth = "180px";
        } else if (width >= 980) {
            imgWidth = "160px";
        } else {
            imgWidth = "140px";
        }

        // PORT==='9021'
        if (port === 9021 && this.props.user_type === "sale") {
            let target = "/cars/list";
            return <Redirect push to={target}/>;
        }

        if (this.state.btnClick === "car-sell-detail") {
            const target = "/car-sell/detail/?car_sell_id=" + this.state.car_sell_id;
            return <Redirect push to={target} target={"_blank"}/>;
        } else if (this.state.btnClick === "finance-tax-invoice") {
            const target =
                "/finance-tax-invoice/?car_sell_id=" + this.state.car_sell_id;
            return <Redirect push to={target} target={"_blank"}/>;
        } else if (this.state.btnClick === "finance-tax/tabs") {
            // finance-tax/tabs
            const target = "/finance-tax/tabs/?car_sell_id=" + this.state.car_sell_id;
            return <Redirect push to={target} target={"_blank"}/>;
        } else if (this.state.btnClick === "sales-claim") {
            const target = "/sales/claim/?" + this.state.car_claim;
            return <Redirect push to={target}/>;
        } else if (this.state.btnClick === "car-detail") {
            let car_id = this.state.car_sell_detail.car_id;
            let car_sell_id = this.state.car_sell_id;
            let upload_code = this.state.car_sell_detail.car_upload_code;
            let target = "/cars/detail/?car_id=" + car_id;
            target += "&upload_code=" + upload_code + "&car_sell_id=" + car_sell_id;
            return <Redirect push to={target}/>;
        } else if (this.state.btnClick === "car-sales-contract") {
            const target =
                "/car-sales-contract/?car_sell_id=" + this.state.car_sell_id;
            return <Redirect push to={target} target={"_blank"}/>;
        } else if (this.state.btnClick === "car-sell-pay-other") {
            const target =
                "/car-sell-pay-other/detail/?car_sell_id=" + this.state.car_sell_id;
            return <Redirect push to={target} target={"_blank"}/>;
        } else if (this.state.btnClick === "car-receipt-ocpd") {
            const target = "/car-receipt-ocpd/?car_sell_id=" + this.state.car_sell_id;
            return <Redirect push to={target} target={"_blank"}/>;
        } else if (this.state.btnClick === "payment-voucher") {
            const target = "/payment-voucher/?car_sell_id=" + this.state.car_sell_id;
            return <Redirect push to={target} target={"_blank"}/>;
        } else if (this.state.btnClick === "car-sales-contract2") {
            const target =
                "/car-sales-contract2/?car_sell_id=" + this.state.car_sell_id;
            return <Redirect push to={target} target={"_blank"}/>;
        } else if (this.state.btnClick === "car-sales-contract-carok") {
            const target =
                "/car-sales-contract-carok/?car_sell_id=" + this.state.car_sell_id;
            return <Redirect push to={target} target={"_blank"}/>;
        } else if (this.state.btnClick === "debtors") {
            const target = "/debtors/list/?" + this.state.debtors_query;
            return <Redirect push to={target}/>;
        } else if (this.state.btnClick === "car-sales-contract-at") {
            let car_sell_detail = this.state.car_sell_detail;
            let customer_id = car_sell_detail.customer_id;
            let car_id = car_sell_detail.car_id;
            let car_sell_id = this.state.car_sell_id;
            const target =
                "/car-sales-contract-at/?customer_id=" +
                customer_id +
                "&car_id=" +
                car_id +
                "&car_sell_id=" +
                car_sell_id;
            return <Redirect push to={target} target={"_blank"}/>;
        } else if (this.state.btnClick === "car-sales-contract-samkor") {
            const target =
                "/car-sales-contract-samkor/?car_sell_id=" + this.state.car_sell_id;
            return <Redirect push to={target} target={"_blank"}/>;
        }

        let car_sell_status_list = this.state.car_status.map(
            (car_status, index) => {
                return (
                    <option key={index} value={car_status.car_status_id}>
                        {car_status.car_status_name}
                    </option>
                );
            }
        );

        let car_sell_type_list = this.state.car_sell_type.map(
            (car_sell_type, index) => {
                return (
                    <option key={index} value={car_sell_type.car_sell_type_id}>
                        {car_sell_type.car_sell_type_name}
                    </option>
                );
            }
        );

        let bank_finance_list = this.state.bank.map((bank, index) => {
            return (
                <option key={index} value={bank.bank_id}>
                    {bank.bank_name}
                </option>
            );
        });

        let to_fixed = 2;

        let all_page = Math.ceil(this.state.car_sell_count / PAGE10);

        let car_sell_count = this.state.car_sell_count;
        let page = this.state.page;
        let start_row = 0;

        let all_page_search = Math.ceil(this.state.count_search / PAGE10);
        let page_search = this.state.page_search;
        let count_search = this.state.count_search;

        if (this.state.is_search === false) {
            if (car_sell_count > 0 && page > 0) {
                start_row = Number(page - 1) * PAGE10;
            }
        } else {
            if (count_search > 0 && page_search > 0) {
                start_row = Number(page_search - 1) * PAGE10;
            }
        }

        // Ensure lists is always an array before mapping
        let listsArray = Array.isArray(this.state.lists) ? this.state.lists : [];
        let tbodyList = listsArray.map((car_sell, index) => {
            // const car_sell_id = car_sell.car_sell_id
            // Todox: check car_sell_id in debtors tb
            // this.checkCarSellDebtors(car_sell_id) loop render
            let car_date_in = car_sell.car_date_in ? moment(car_sell.car_date_in) : null;
            let date_promise = car_sell.date_promise ? moment(car_sell.date_promise) : null;
            let day_stay = "-";
            if (date_promise && car_date_in && date_promise > car_date_in) {
                day_stay = date_promise.diff(car_date_in, "days");
            }

            //อิงตามวันที่ออกรถ/ปล่อยรถ
            let car_issue_date = car_sell.car_issue_date ? moment(car_sell.car_issue_date) : null;
            let current_date = moment(new Date());
            let day_issue = "-";
            if (car_issue_date) {
                day_issue = current_date.diff(car_issue_date, "days");
            }
            let day_issue_ago = day_issue !== "-" ? DateUtil.convertDaysToMonthsDays(day_issue) : "-";
            // console.log(day_issue, 'วัน', day_issue_ago)


            let order = 0;

            if (this.state.is_search && this.state.count_search > 10) {
                order = Number(count_search - start_row) - index;
            } else if (this.state.is_search) {
                order = index + 1;
            } else {
                order = Number(car_sell_count - start_row) - index;
            }

            let image_url = "";
            // Add null/undefined checks for car_upload_filename
            if (car_sell.car_upload_filename && car_sell.car_upload_filename.includes("https")) {
                // image_url = car_sell.car_upload_filename
                let car_upload_key = car_sell.car_upload_key;
                image_url = CLOUDFRONT_URL + car_upload_key;
            } else if (car_sell.car_upload_filename) {
                image_url = IMAGE_FULL_URL + car_sell.car_upload_filename;
            } else {
                // Fallback for missing images
                image_url = "/assets/images/no-car-image.jpg";
            }

            image_url = this.state.carImageBase64
            //let license = car_sell.car_license_plate_new

            //อันเดิมที่คำนวณ ราคาขายจริง + รายรับ ( VAT ยอดจัด, ค่าคอมมิชชั่นไฟแนนซ์, VAT คอมมิชชั่น) แล้ว นำมาลบกับต้นทุนรถ และส่วนลดเงินดาวน์ (ถ้ามี)
            //let sum_car_profit = sum_car_income_total - (sum_car_cost_total + sum_car_sell_expense)
            //let commission_vat = car_sell.vat_commission === 0 ? car_sell.tax_commission_vat : car_sell.vat_commission

            let car_sell_type_id = Number(car_sell.car_sell_type_id);
            let real_sell_price = Number(car_sell.real_sell_price);
            let tax_invoice_amount = Number(car_sell.tax_invoice_amount);
            let rate_finance = Number(car_sell.rate_finance);
            let sum_down = Number(car_sell.sum_down);
            let rate_finance_tax_invoice_amount = tax_invoice_amount !== 0 ? tax_invoice_amount : rate_finance;

            /*const tax_commission_total = port === 9048 ? 0 : car_sell.tax_commission_total;
      const finance_commission = port === 9048 ? 0 : car_sell.finance_commission;
      const tax_finance_commission_total = finance_commission !== 0 ? finance_commission : tax_commission_total;*/

            //ลูกค้าไม่ออกใบกำกับค่าคอมแต่คีย์ลงในรายรับการขาย กรณีคีย์รายรับตอนทำขายครั้งแรก ยอดจะไปบันทึกที่ tax_commission_amount
            //ถ้าไม่ออกใบกำกับ คีย์รายรับเฉยๆ ขแก้ไขการขาย ้อมูลจะบันทึกที่ฟิลด์ finance_commission + vat_commission
            //ออกใบกำกับ ้อมูลจะบันทึกที่ฟิลด์ tax_commission_amount + tax_commission_vat = tax_commission_total
            //หน้าการขายบางคันแสดงค่าคอมไฟแนนซ์ บางคันไม่แสดง ลูกค้า งง
            const tax_commission_total = port === 9048 ? 0 : car_sell.tax_commission_total;
            let finance_commission = car_sell.tax_commission_amount !== 0 ? car_sell.tax_commission_amount : car_sell.finance_commission;
            if (port === 9048) {
                finance_commission = 0
            }
            let commission_vat = car_sell.vat_commission !== 0 ? car_sell.vat_commission : car_sell.tax_commission_vat
            if (port === 9048) {
                commission_vat = 0
            }
            const tax_finance_commission_total = finance_commission + commission_vat

            const tax_invoice_vat = port === 9048 ? 0 : car_sell.tax_invoice_vat;

            if (port === 9048 && car_sell_type_id === 1) {
                tax_invoice_amount = rate_finance;
            }

            //9069 เพิ่มรายรับ ราคาประกัน, เก็บค่างวดรถล่วงหน้า, ค่าดำเนินการ/ค่าโอน
            const insurance_price =
                car_sell.insurance_buy === "ประกันแถม" ? 0 : car_sell.insurance_price;
            const pay_advance_finance = car_sell.pay_advance_finance;
            const cost_finance = car_sell.cost_finance;

            let sum_car_income = rate_finance_tax_invoice_amount + sum_down;
            //รายรับที่เต็นท์ได้จากการที่ลูกค้าจ่ายเพิ่ม 9069
            let sum_car_tent_income =
                insurance_price + pay_advance_finance + cost_finance;

            //อันใหม่ตามที่ sc แจ้งมา ยอดจัดไฟแนนซ์+เงินดาวน์ -ต้นทุนรถ-ค่าคอมมิชชั่น-ค่าซ่อม-ค่าอื่นๆที่เกี่ยวกับตัวรถ
            // ขายเงินสด คำนวณจากราคาขายจริง car_sell_type_id === 1
            // รายรับ
            let sum_car_income_total =
                car_sell_type_id === 1 ? real_sell_price : sum_car_income;

            //ค่าใช้จ่ายตอนรถเข้า
            // ไม่รวมค่าซ่อม ปรับ 12/11/2566
            /*let sum_car_cost_total = 0 //ต้นทุน
      sum_car_cost_total = car_sell.car_cost + car_sell.vat_buy + car_sell.car_cost_commissions +
          car_sell.car_cost_tax + car_sell.car_cost_act + car_sell.car_cost_other + car_sell.car_cost_expenses_other +
          car_sell.cost_operation + car_sell.cost_service + car_sell.cost_transport + car_sell.cost_porobor_lan +
          car_sell.cost_bangkhab_phasi_lan + car_sell.cost_bangkhab_xon_lan + car_sell.cost_check_ton*/
            let sum_car_cost_total =
                (car_sell.car_cost === null || car_sell.car_cost === undefined ? 0 : car_sell.car_cost) +
                (car_sell.vat_buy === null || car_sell.vat_buy === undefined ? 0 : car_sell.vat_buy) +
                getSumCostBeforeSellNoRepair(car_sell);

            // ค่าซ่อมรถ (ก่อนขาย) ปรับ 12/11/2566
            let sum_car_cost_repair =
                car_sell.car_cost_repair === null || car_sell.car_cost_repair === undefined ? 0 : car_sell.car_cost_repair;

            let sum_cost_sell_and_finance =
                getSumCostAfterSell(car_sell) + getSumCostFinanceAfterSell(car_sell);

            // ยอดจัดเกิน
            let car_excess_amount_use = getSumCostSellPayByCustomer(car_sell);

            //รวมต้นทุนทั้งสิ้น
            let sum_car_cost_finish = 0;
            if (port === 9048) {
                sum_car_cost_finish =
                    sum_car_cost_total + sum_car_cost_repair + sum_cost_sell_and_finance;
            } else {
                sum_car_cost_finish =
                    sum_car_cost_total + sum_car_cost_repair + sum_cost_sell_and_finance;
            }

            // เงินคืนลูกค้า
            //refund_type = 1 คืนเงินเต็ม
            //refund_type = 2 ไม่คืนเงิน
            //refund_type = 3 คืนเงินบางส่วน
            /*let customer_cash = 0
      if(car_sell.refund_type === 0){
        customer_cash = 0
      }else if(car_sell.refund_type === 1){
        customer_cash = car_sell.customer_cash
      }else if(car_sell.refund_type === 2){
        customer_cash = 0
      }else if(car_sell.refund_type === 3){
        customer_cash = car_sell.refund_inpart
      }*/

            let refund_cash = 0;
            let refund_difference = 0;
            const car_excess_amount = car_sell.car_excess_amount;
            const customer_cash = car_sell.customer_cash;
            if (car_excess_amount > 0) {
                // เงินคืนลูกค้า
                //refund_type = 1 คืนเงินเต็ม
                //refund_type = 2 ไม่คืนเงิน
                //refund_type = 3 คืนเงินบางส่วน
                if (car_sell.refund_type === 0) {
                    refund_cash = 0;
                } else if (car_sell.refund_type === 1) {
                    refund_cash = car_sell.customer_cash;
                } else if (car_sell.refund_type === 2) {
                    refund_cash = 0;
                } else if (car_sell.refund_type === 3) {
                    refund_cash = car_sell.refund_inpart;
                }
                refund_difference = customer_cash - refund_cash;
            }

            // คำนวณกำไร - ยอดตั้งหนี้ค้างดาวน์
            // console.log('--------------', car_sell.car_license_plate_new)
            // console.log('income=', sum_car_income_total + tax_commission_total + tax_invoice_vat + refund_difference)
            // console.log('-', sum_car_cost_finish)
            // console.log('-', refund_cash)
            // console.log('-', car_excess_amount_use)
            // console.log('-', Number(car_sell.amount_of_debt))

            let sum_car_profit =
                sum_car_income_total +
                tax_finance_commission_total +
                tax_invoice_vat +
                refund_difference -
                sum_car_cost_finish -
                refund_cash -
                car_excess_amount_use -
                Number(car_sell.amount_of_debt);
            // let sum_car_profit = (sum_car_income_total + tax_commission_total + tax_invoice_vat + refund_difference) - (sum_car_cost_finish ) - (refund_cash)  - Number(car_sell.amount_of_debt)
            if (port === 9048) {
                sum_car_profit =
                    sum_car_income_total +
                    tax_finance_commission_total +
                    tax_invoice_vat -
                    sum_car_cost_finish -
                    refund_cash;
            } else if (port === 9069) {
                //sum_car_profit = (sum_car_income_total + tax_finance_commission_total + tax_invoice_vat ) + (sum_car_tent_income) - (sum_car_cost_finish ) - (refund_cash)
                sum_car_profit += sum_car_tent_income;
            }

            let amount_of_debt =
                car_sell.amount_of_debt === 0
                    ? 0
                    : Number(car_sell.amount_of_debt) * -1;

            /*if (port !== 9048) {
        // รวมกำไร - ยอดตั้งหนี้ค้างดาวน์
        sum_car_profit = sum_car_profit - Number(car_sell.amount_of_debt)
      }*/

            let sell_comment = car_sell.sell_comment === null || car_sell.sell_comment === ""
                    ? "-" : car_sell.sell_comment;

            return (
                <tr className="text-center" key={index}>
                    <td className="text-center">{order}</td>

                    {PORT === 9048 ? (
                        <td className="text-left">
                            วันที่ซื้อรถเข้า : <br/>
                            {moment(car_sell.car_date_in).locale("th").format("LL")}
                            <hr/>
                            จำนวนวันที่ออกรถ/ปล่อยรถ : {day_issue} วัน <br/>
                            <strong>({day_issue_ago})</strong>
                            <hr/>
                            <strong>เลขที่ใบเสร็จ/ใบกำกับ</strong>
                            <br/>
                            ไฟแนนซ์ :{" "}
                            {car_sell.tax_invoice_number === null ||
                            car_sell.tax_invoice_number === "" ||
                            car_sell.tax_invoice_status !== "normal"
                                ? "-"
                                : car_sell.tax_invoice_number}
                            <br/>
                            ค่าคอม :{" "}
                            {car_sell.tax_commission_number === null ||
                            (car_sell.tax_commission_number === "" &&
                                car_sell.tax_commission_status !== "normal")
                                ? "-"
                                : car_sell.tax_commission_number}
                            <hr/>
                            <div style={{width: 250, wordWrap: "break-word"}}>
                                หมายเหตุการขาย : <br/>
                                {sell_comment}
                            </div>
                        </td>
                    ) : (
                        <td className="text-left">
                            วันที่ซื้อรถเข้า : {moment(car_sell.car_date_in).locale("th").format("LL")}
                            <hr/>
                            วันที่ทำสัญญา/นัด : {moment(car_sell.date_promise).locale("th").format("LL")}
                            <hr/>
                            วันต่อภาษี: {moment(car_sell.car_date_tax).locale("th").format("LL")}
                            <hr/>
                            งวดแรก(วันที่) : {car_sell.first_installment === null ||
                        car_sell.first_installment === "0000-00-00"
                            ? "-"
                            : moment(car_sell.first_installment).locale("th").format("LL")}
                            <hr/>
                            จน.วันที่รถจอด : {day_stay} วัน
                            <hr/>
                            จน.วันที่ออกรถ/ปล่อยรถ : {day_issue} วัน <br/>
                            <strong>({day_issue_ago})</strong>
                            {PORT === 9043 && this.props.type !== "admin" ? null : (
                                <>
                                    <hr/>
                                    <strong>เลขที่ใบเสร็จ/ใบกำกับ</strong>
                                    <br/>
                                    ไฟแนนซ์ :{" "}
                                    {car_sell.tax_invoice_number === null ||
                                    car_sell.tax_invoice_number === "" ||
                                    car_sell.tax_invoice_status !== "normal"
                                        ? "-"
                                        : car_sell.tax_invoice_number}
                                    <br/>
                                    ค่าคอม :{" "}
                                    {car_sell.tax_commission_number === null ||
                                    car_sell.tax_commission_number === "" ||
                                    car_sell.tax_commission_status !== "normal"
                                        ? "-"
                                        : car_sell.tax_commission_number}
                                </>
                            )}
                            <hr/>
                           <div style={{width: 250, wordWrap: "break-word"}}>
                                หมายเหตุการขาย : <br/>
                                {sell_comment}
                            </div>
                        </td>
                    )}

                    <td className="text-wrap text-left" style={{width: 280}}>
                        <img
                            src={image_url}
                            style={{cursor: "pointer", width: imgWidth, height: "auto"}}
                            alt="car"
                        />
                        <hr/>
                        <p className="text-center">ผู้ซื้อ : {(car_sell.customer_name || '')}&nbsp;&nbsp;&nbsp;
                            {(car_sell.customer_lastname || '')}</p>
                        <p className="text-center">เบอร์โทรศัพท์ : {(car_sell.customer_mobile || '-')}</p>
                        <p className="text-center">
                            {car_sell.customer_mobile2 === null ||
                            car_sell.customer_mobile2 === "" ||
                            car_sell.customer_mobile2 === undefined ? null : (
                                <>เบอร์โทรศัพท์ : {car_sell.customer_mobile2}</>
                            )}
                        </p>
                        <hr/>
                        <div className="text-center">
                            {checkGroupPermission(127, this.state.grouppermissions).viewed
                                ? car_sell.is_star === 1 && (

                                <img src={star} style={styles.star} className="mr-1" alt="star"/>
                            )
                                : null}
                            {(car_sell.car_name || '-')} &nbsp; {"สี"}{(car_sell.car_color_name || '-')}
                        </div>

                        ทะเบียนใหม่ : {(car_sell.car_license_plate_new || '-')} &nbsp;{(car_sell.province_name_new || '')} <br/>
                        (ทะเบียนเดิม : {(car_sell.car_license_plate_old || '-')} &nbsp;{(car_sell.province_name_old || '')}) <br/>
                        {PORT === 9043 && this.props.type !== "admin" ? null : (
                            <>
                                ซื้อรถจาก :{" "}
                                {car_sell.buy_car_from === null || car_sell.buy_car_from === ""
                                    ? "-"
                                    : car_sell.buy_car_from}
                            </>
                        )}
                        <hr/>
                        <textarea
                            id="sell_list_note"
                            name="sell_list_note"
                            style={{backgroundColor: "#ffffff", width: 250}}
                            value={car_sell.sell_list_note}
                            onChange={(e) =>
                                this.onCarSellListNoteFormEdit(e, car_sell.car_sell_id)
                            }
                            placeholder=" หมายเหตุ"
                        ></textarea>
                        <br/>
                        <button
                            className={
                                car_sell.car_sell_edit ? "btn btn-sm btn-primary " : "hidden"
                            }
                            onClick={() =>
                                this.onCarSellListNoteUpdate(
                                    car_sell.car_sell_id,
                                    car_sell.sell_list_note
                                )
                            }
                        >
                            บันทึก
                        </button>
                        <div className={car_sell.car_sell_save ? "fadeOut" : "hidden"}>
                            <span className="text-success"> บันทึกเรียบแล้ว </span>
                        </div>
                        <hr/>
                        {PORT === 9048 ? null : (
                            <>
                <span className="text-danger">
                  โปรโมชั่น :{" "}
                    {car_sell.promotion_name === ""
                        ? "-"
                        : car_sell.promotion_name}
                </span>
                                <br/>
                            </>
                        )}
                        วันที่ขาย :{" "}
                        {moment(car_sell.car_sell_date).locale("th").format("LL")} โดย :{" "}
                        {car_sell.car_sell_user}
                        <br/>
                        <span className="text-primary">
              วันที่ออกรถ :{" "}
                            {moment(car_sell.car_issue_date).locale("th").format("LL")}
            </span>
                        <br/>
                        <span>
              ประเภท : {CarUtil.convertVatPersonToName(car_sell.person_vat_id)}
            </span>
                        <br/>
                        <span> ไฟแนนซ์ : {(car_sell.bank_finance_name_new || '-')} </span>
                        <br/>
                        <span>
              ค่างวดรถ :&nbsp;
                            <NumberFormat
                                value={Number(car_sell.monthly_installment || 0)}
                                displayType={"text"}
                                thousandSeparator={true}
                            />
                            &nbsp; ต่อเดือน
            </span>
                        {car_sell.sale_by_id === null ||
                        car_sell.sale_by_id === 0 ? null : (
                            <>
                                <hr/>
                                <span>
                  ขายโดย : {(car_sell.sale_name || '')} {(car_sell.sale_lastname || '')}
                </span>
                            </>
                        )}
                        <br/>
                        {car_sell.agent_id === null ? null : (
                            <>
                                <span>
                  นายหน้า : {(car_sell.agent_fullname || '')}
                    <br />
                    {PORT !== 9048 && car_sell.agent_mobile ? "(" + car_sell.agent_mobile + ")" : null}
                </span>
                            </>
                        )}
                    </td>

                    <td>
                        <center>
                            <p
                                className="badge"
                                style={{backgroundColor: car_sell.car_status_color}}
                            >
                                {car_sell.car_status_name}
                            </p>
                            <table className="table2 text-nowrap">
                                <>
                                    {PORT === 9048 && this.props.type === "sale" || this.props.type === "manager" ? null : (
                                        <tbody>
                                        <tr>
                                            <td className="text-left text-nowrap">ราคาปกติ :</td>
                                            <td className="text-right text-nowrap">
                                                <strong>
                                                    <NumberFormat
                                                        value={Number(car_sell.normal_sell_price || 0).toFixed(
                                                            to_fixed
                                                        )}
                                                        displayType={"text"}
                                                        thousandSeparator={true}
                                                        decimalScale={2}
                                                    />
                                                    &nbsp; บาท
                                                </strong>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left text-nowrap">
                                                ราคาขายจริง :{" "}
                                            </td>
                                            <td className="text-right text-nowrap">
                                                <strong>
                                                    <NumberFormat
                                                        value={Number(car_sell.real_sell_price || 0).toFixed(to_fixed)}
                                                        displayType={"text"}
                                                        thousandSeparator={true}
                                                    />
                                                    &nbsp; บาท
                                                </strong>
                                            </td>
                                        </tr>

                                        {PORT === 9048 &&
                                        car_sell.car_sell_type_id === 1 &&
                                        car_sell.car_sell_discount > 0 ? (
                                            <tr>
                                                <td className="text-left text-nowrap">ส่วนลด :</td>
                                                <td className="text-right text-nowrap">
                                                    <NumberFormat
                                                        value={Number(car_sell.car_sell_discount || 0).toFixed(
                                                            to_fixed
                                                        )}
                                                        displayType={"text"}
                                                        thousandSeparator={true}
                                                    />
                                                    &nbsp; บาท
                                                </td>
                                            </tr>
                                        ) : null}

                                        {tax_invoice_amount !== 0 ? (
                                            <tr>
                                                <td className="text-left text-nowrap text-success">
                                                    ยอดจัดไฟแนนซ์ :{" "}
                                                </td>
                                                <td className="text-right text-nowrap text-success">
                                                    <NumberFormat
                                                        value={Number(tax_invoice_amount || 0).toFixed(to_fixed)}
                                                        displayType={"text"}
                                                        thousandSeparator={true}
                                                    />
                                                    &nbsp; บาท
                                                </td>
                                            </tr>
                                        ) : (
                                            <tr>
                                                <td className="text-left text-nowrap">
                                                    ยอดจัดไฟแนนซ์ :{" "}
                                                </td>
                                                <td className="text-right text-nowrap">
                                                    <NumberFormat
                                                        value={Number(rate_finance || 0).toFixed(to_fixed)}
                                                        displayType={"text"}
                                                        thousandSeparator={true}
                                                    />
                                                    &nbsp; บาท
                                                </td>
                                            </tr>
                                        )}

                                        {car_sell.sell_discount === 0 ? null : (
                                            <tr>
                                                <td className="text-left text-nowrap">
                                                    ส่วนลดเงินดาวน์ :{" "}
                                                </td>
                                                <td className="text-right text-nowrap">
                                                    <NumberFormat
                                                        value={Number(car_sell.sell_discount || 0).toFixed(to_fixed)}
                                                        displayType={"text"}
                                                        thousandSeparator={true}
                                                    />
                                                    &nbsp; บาท
                                                </td>
                                            </tr>
                                        )}

                                        <tr>
                                            <td className="text-left text-nowrap">ยอดดาวน์ :</td>
                                            <td className="text-right text-nowrap">
                                                <NumberFormat
                                                    value={Number(car_sell.sum_down || 0).toFixed(to_fixed)}
                                                    displayType={"text"}
                                                    thousandSeparator={true}
                                                />
                                                &nbsp; บาท
                                            </td>
                                        </tr>

                                        {car_sell.vat_down === 0 ? null : (
                                            <tr>
                                                <td className="text-left text-nowrap">
                                                    VAT ดาวน์ :{" "}
                                                </td>
                                                <td className="text-right text-nowrap">
                                                    <NumberFormat
                                                        value={Number(car_sell.vat_down || 0).toFixed(to_fixed)}
                                                        displayType={"text"}
                                                        thousandSeparator={true}
                                                    />
                                                    &nbsp; บาท
                                                </td>
                                            </tr>
                                        )}

                                        <tr>
                                            <td className="text-left text-nowrap">รวมออกรถ :</td>
                                            <td className="text-right text-nowrap">
                                                <NumberFormat
                                                    value={Number(car_sell.total_outof_car || 0).toFixed(to_fixed)}
                                                    displayType={"text"}
                                                    thousandSeparator={true}
                                                />
                                                &nbsp; บาท
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-left text-nowrap">
                                                เงินคืนลูกค้า{" "}
                                                {car_sell.refund_type === 1
                                                    ? "(คืน)"
                                                    : car_sell.refund_type === 2
                                                        ? "(ไม่คืน)"
                                                        : car_sell.refund_type === 3
                                                            ? "(บางส่วน)"
                                                            : "(ไม่ระบุ)"}{" "}
                                                :{" "}
                                            </td>
                                            <td className="text-right text-nowrap">
                                                <NumberFormat
                                                    value={
                                                        car_sell.refund_inpart !== 0 &&
                                                        car_sell.refund_type === 3
                                                            ? Number(car_sell.refund_inpart || 0).toFixed(to_fixed)
                                                            : Number(car_sell.customer_cash || 0).toFixed(to_fixed)
                                                    }
                                                    displayType={"text"}
                                                    thousandSeparator={true}
                                                />
                                                &nbsp; บาท
                                            </td>
                                        </tr>

                                        {port === 9038 || port === 9039 ? (
                                            <tr>
                                                <td className="text-left text-nowrap">
                                                    ส่งเสริมการขาย :
                                                </td>

                                                <td className="text-right text-nowrap">
                                                    <strong>
                                                        <NumberFormat
                                                            value={Number(car_sell.cost_finance || 0).toFixed(to_fixed)}
                                                            displayType={"text"}
                                                            thousandSeparator={true}
                                                        />
                                                        &nbsp; บาท
                                                    </strong>
                                                </td>
                                            </tr>
                                        ) : null}

                                        <tr>
                                            <td colSpan={2} className="text-center text-nowrap">
                                                <OutstandingBalanceComponent
                                                    car_id={car_sell.car_id}
                                                    customer_id={car_sell.customer_id}
                                                    balance_debt={car_sell.balance_debt}
                                                    bank_finance_id={car_sell.bank_finance_id}
                                                    car_sell={car_sell}
                                                    to_fixed={to_fixed}
                                                    // setCarSellRemain={(remain, car_sell_id) => {

                                                    //   this.setState({
                                                    //     car_sell_remain: remain
                                                    //   });
                                                    // }}
                                                />
                                            </td>
                                        </tr>
                                        <tr
                                            className={
                                                (this.props.type === "admin" ||
                                                    this.props.type === "manager") &&
                                                port === 9043
                                                    ? "text-primary"
                                                    : "hidden"
                                            }
                                        >
                                            <td colSpan={2} className="text-center">
                                                {/*<button onClick={() => this.onExcelCostPerCar(car_sell)} type="button"
                             className={'btn btn-success btn-sm btn-block'}
                          >
                            <i className="icon-cloud-download">&nbsp;Excel ต้นทุนรายคัน</i>
                          </button>*/}
                                                <button
                                                    onClick={() => {
                                                    }}
                                                    type="button"
                                                    className={"btn btn-success btn-sm btn-block"}
                                                >
                                                    <Link
                                                        to={
                                                            "/car-cost/?car_id=" +
                                                            car_sell.car_id +
                                                            "&customer_id=" +
                                                            car_sell.customer_id +
                                                            "&car_sell_id=" +
                                                            car_sell.car_sell_id
                                                        }
                                                        target="_blank"
                                                        style={{color: "white"}}
                                                    >
                                                        <i className="icon-eye">&nbsp;ต้นทุนรายคัน</i>
                                                    </Link>
                                                </button>
                                            </td>
                                        </tr>

                                        <>
                                            {port !== 9048 &&
                                            port !== 9070 &&
                                            this.checkCostPermission() &&
                                            tax_invoice_vat !== 0 &&
                                            car_sell.tax_invoice_status !== "cancel" ? (
                                                <tr className="text-success">
                                                    <td className="text-left text-nowrap">
                                                        <span>+ VAT ของยอดจัด :</span>
                                                    </td>
                                                    <td className="text-right text-success text-nowrap">
                              <span>
                                <NumberFormat
                                    value={Number(tax_invoice_vat || 0).toFixed(to_fixed)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                />{" "}
                                  &nbsp; บาท
                              </span>
                                                    </td>
                                                </tr>
                                            ) : null}
                                        </>

                                        <>
                                            {port !== 9048 && tax_finance_commission_total !== 0 && car_sell.tax_commission_status !== "cancel"
                                            && this.checkCostPermission() ? (
                                                <tr className="text-success">
                                                    <td className="text-left text-nowrap">
                                                        <span>+ ค่าคอมไฟแนนซ์ :</span>
                                                    </td>
                                                    <td className="text-right text-success text-nowrap">
                              <span>
                                <NumberFormat
                                    value={Number(tax_finance_commission_total || 0).toFixed(
                                        to_fixed
                                    )}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                />{" "}
                                  &nbsp; บาท
                              </span>
                                                    </td>
                                                </tr>
                                            ) : null}
                                        </>

                                        <>
                                            {port === 9069 &&
                                            this.checkCostPermission() &&
                                            insurance_price !== 0 ? (
                                                <tr className="text-success">
                                                    <td className="text-left text-nowrap">
                                                        <span>+ ประกันรถยนต์ :</span>
                                                    </td>
                                                    <td className="text-right text-success text-nowrap">
                              <span>
                                <NumberFormat
                                    value={Number(insurance_price || 0).toFixed(to_fixed)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                />{" "}
                                  &nbsp; บาท
                              </span>
                                                    </td>
                                                </tr>
                                            ) : null}
                                        </>

                                        <>
                                            {port === 9069 &&
                                            this.checkCostPermission() &&
                                            pay_advance_finance !== 0 ? (
                                                <tr className="text-success">
                                                    <td className="text-left text-nowrap">
                                                        <span>+ ค่างวดรถล่วงหน้า :</span>
                                                    </td>
                                                    <td className="text-right text-success text-nowrap">
                              <span>
                                <NumberFormat
                                    value={Number(pay_advance_finance || 0).toFixed(to_fixed)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                />{" "}
                                  &nbsp; บาท
                              </span>
                                                    </td>
                                                </tr>
                                            ) : null}
                                        </>

                                        <>
                                            {port === 9069 &&
                                            this.checkCostPermission() &&
                                            cost_finance !== 0 ? (
                                                <tr className="text-success">
                                                    <td className="text-left text-nowrap">
                                                        <span>+ ค่าดำเนินการ/ค่าโอน :</span>
                                                    </td>
                                                    <td className="text-right text-success text-nowrap">
                              <span>
                                <NumberFormat
                                    value={Number(cost_finance || 0).toFixed(to_fixed)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                />{" "}
                                  &nbsp; บาท
                              </span>
                                                    </td>
                                                </tr>
                                            ) : null}
                                        </>

                                        <>
                                            {this.checkCostPermission() ? (
                                                <tr className="text-dark">
                                                    <td className="text-left text-nowrap">
                                                        <span>ต้นทุนรถ :</span>
                                                    </td>
                                                    <td className="text-right text-dark text-nowrap">
                              <span>
                                <NumberFormat
                                    value={Number(sum_car_cost_total || 0).toFixed(to_fixed)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                />{" "}
                                  &nbsp; บาท
                              </span>
                                                    </td>
                                                </tr>
                                            ) : null}
                                        </>

                                        <>
                                            {this.checkCostPermission() ? (
                                                <tr className="text-dark">
                                                    <td className="text-left text-nowrap">
                                                        <span>ค่าซ่อมรถ :</span>
                                                    </td>
                                                    <td className="text-right text-dark text-nowrap">
                              <span>
                                <NumberFormat
                                    value={Number(sum_car_cost_repair || 0).toFixed(to_fixed)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                />{" "}
                                  &nbsp; บาท
                              </span>
                                                    </td>
                                                </tr>
                                            ) : null}
                                        </>

                                        {this.renderCostSell(car_sell, to_fixed)}

                                        <>
                                            {this.checkCostPermission() ? (
                                                <tr className="text-dark">
                                                    <td className="text-left text-nowrap">
                                                        <strong>รวมต้นทุนทั้งสิ้น :</strong>
                                                    </td>
                                                    <td className="text-right text-dark text-nowrap">
                                                        <strong>
                                                            <NumberFormat
                                                                value={Number(sum_car_cost_finish || 0).toFixed(to_fixed)}
                                                                displayType={"text"}
                                                                thousandSeparator={true}
                                                            />{" "}
                                                            &nbsp; บาท
                                                        </strong>
                                                    </td>
                                                </tr>
                                            ) : null}
                                        </>

                                        <>
                                            {port !== 9048 &&
                                            this.checkCostPermission() &&
                                            amount_of_debt !== 0 ? (
                                                <tr
                                                    className={
                                                        amount_of_debt < 0 ? "text-danger" : "text-danger"
                                                    }
                                                >
                                                    <td className="text-left text-nowrap ">
                                                        <strong> ตั้งหนี้ : </strong>
                                                    </td>
                                                    <td className="text-right text-nowrap">
                                                        <strong>
                                                            <NumberFormat
                                                                value={Number(amount_of_debt || 0).toFixed(to_fixed)}
                                                                displayType={"text"}
                                                                thousandSeparator={true}
                                                                allowNegative={true}
                                                                decimalScale={2}
                                                            />{" "}
                                                            &nbsp; บาท
                                                        </strong>
                                                    </td>
                                                </tr>
                                            ) : null}
                                        </>

                                        <>
                                            {this.checkCostPermission() ? (
                                                <tr
                                                    className={
                                                        sum_car_profit < 0
                                                            ? "text-danger"
                                                            : "text-success"
                                                    }
                                                >
                                                    <td className="text-left text-nowrap">
                                                        <strong> ≈ กำไร-ขาดทุน : </strong>
                                                    </td>
                                                    <td className="text-right text-nowrap">
                                                        <strong>
                                                            <NumberFormat
                                                                value={Number(sum_car_profit || 0).toFixed(to_fixed)}
                                                                decimalScale={2}
                                                                displayType={"text"}
                                                                thousandSeparator={true}
                                                            />{" "}
                                                            &nbsp; บาท
                                                        </strong>
                                                    </td>
                                                </tr>
                                            ) : null}
                                        </>
                                        </tbody>
                                    )}
                                </>
                            </table>

                            {car_sell.debtors_type_id === 1 ? (
                                <>
                                    <br/>
                                    <span
                                        className={
                                            car_sell.debtors_type_id === 1 &&
                                            car_sell.debtors_status === "show"
                                                ? "badge badge-warning"
                                                : "hidden"
                                        }
                                    >
                  ตั้งหนี้แล้ว #{car_sell.debtors_id}
                </span>
                                    <br/>
                                    <DebtWarning
                                        debtors_id={car_sell.debtors_id}
                                        car_id={car_sell.car_id}
                                        customer_id={car_sell.customer_id}
                                        car_sell_id={car_sell.car_sell_id}
                                        warning_type="car_sell"
                                    />
                                </>
                            ) : (
                                <>
                                    <br/>
                                    <DebtWarning
                                        debtors_id={car_sell.debtors_id}
                                        car_id={car_sell.car_id}
                                        customer_id={car_sell.customer_id}
                                        car_sell_id={car_sell.car_sell_id}
                                        warning_type="car_sell"
                                    />
                                </>
                            )}
                        </center>
                    </td>
                </tr>
            );
        });

        let month_year_list_option = this.state.month_year_list.map(
            (month_year, index) => (
                <option key={index} value={month_year.month_list}>
                    {month_year.month_list_thai}
                </option>
            )
        );

        //let bill_no = 'IV'+ this.state.car_sell_id
        let real_sell_price = Number(this.state.real_sell_price).toLocaleString();
        let rate_finance = Number(this.state.rate_finance).toLocaleString();
        let sum_down = Number(this.state.sum_down).toLocaleString();
        let pay_advance_finance = Number(
            this.state.pay_advance_finance
        ).toLocaleString();
        let insurance_price = Number(this.state.insurance_price).toLocaleString();
        let cost_finance = Number(this.state.cost_finance).toLocaleString();

        return (
            <Modal isOpen={isOpen} toggle={toggle} style={{maxWidth: '1200px'}}>
                <ModalBody>
                    <Loading isLoading={this.state.isLoading}/>

                    {/* Image capture container */}
                    <div ref={this.imageCaptureRef} style={{backgroundColor: 'white', padding: '5px'}}>

                        {/* Header for image */}
                        <div className="text-center mb-4">
                            <strong className="text-title">สรุปการขายรายคัน</strong>
                            <p className="text-muted mb-1">
                                {moment().locale('th').format('LL เวลา HH:mm:ss')}
                            </p>
                        </div>

                        <div className="card card-accent-primary">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-12 mb-3">
                                        <strong className="text-title"> ข้อมูลการขายรถ </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="card-block">

                                <table className="table table-striped">
                                    <thead>
                                    <tr>
                                        <th className="text-center" width="5%">#</th>
                                        <th className="text-center" width="30%">วันที่</th>
                                        <th className="text-center">ผู้ซื้อ/ชื่อรถ</th>
                                        <th className="text-center" width="25%">สถานะ/การเงิน</th>
                                    </tr>
                                    </thead>
                                    <tbody>{tbodyList}</tbody>
                                </table>

                            </div>
                        </div>
                    </div>

                </ModalBody>
                <ModalFooter>
                    <Button color="info" onClick={() => this.handleDownloadImage(this.state.car_sell_id)}
                            disabled={this.state.isDownloadImage}>
                        <i className="icon-camera mr-2"/>
                        {this.state.isDownloadImage ? 'กำลังสร้างรูปภาพ...' : 'Download as Image'}
                    </Button>
                    {/*<Button color="success" onClick={this.handleDownloadPDF}>
                        <i className="icon-cloud-download mr-2"/>
                        ดาวน์โหลด PDF
                    </Button>*/}
                    <Button color="secondary" onClick={toggle}>
                        ปิด
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}

const styles = {
    star: {
        width: 40,
    }
}

const mapStateToProps = (state) => ({
    user: state.auth.user,
    type: state.auth.type,
    token: state.auth.token,
    isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(CarSalesSummaryModal);
